import { Component, ViewChild, ElementRef, OnInit, NgZone, Output, Inject, AfterViewInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params } from '@angular/router';

import { HttpService } from "./service/http.service";
import { UserPlanService } from "./service/userplan.service";
import * as _ from 'lodash';
import { DOCUMENT } from '@angular/common';
import {BuildingsService} from "./service/buildings.service";
import {UserService} from "./service/user.service";
import {isNullOrUndefined} from "util";
import { eventEmitterService } from './service/eventEmitter.service';
import { PostFilterService } from './service/post-filter.service';
import {FeedService} from "./service/feed.service";
import {EventService} from "./service/event.service";
import {MaintananceService} from "./service/maintanance.service";
import { UserInfoService } from './service/user-info.service';
import { Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
declare var window:any;
declare var $:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

})
export class AppComponent implements OnInit{

  isAuthenticated;
  private timer;
  private sub: Subscription;
  id = localStorage.getItem('residents');
  isManager;
  userBuildingId;
  userProfile: any;
  authenticatedSub = new Subject();
  currentUrl;
  chatWindow = true;
  error;
  localId;
  isAManager;
  type;
  Url;
  allFeeds;
  skip = 0;
  limit = 5;
  nextFeedLoading = false;
  nextFeedLoader = new Subject();
  modalHeight='';
  windowInnerHeight='';
  isHeaderToShow:boolean = false;


  unreadAlerts;
  buildingIds = [];
  isScriptAdded:boolean = true;
  isSocketConnected =  false;

  constructor( private httpService: HttpService,
               private plan : UserPlanService,
               private route: ActivatedRoute,
               private router: Router,
               private buildingService: BuildingsService,
               private userService: UserService,
               private ngZone: NgZone,
              @Inject(DOCUMENT) private document: Document,
               private link: PostFilterService,
               private _feed: FeedService,
               private eventService: EventService,
               private maintenance: MaintananceService,
               private eventEmit: eventEmitterService,
              private userInfo: UserInfoService,
              private elementRef: ElementRef){}

  @HostListener('window:beforeunload', ['$event'])
  public beforeunloadHandler($event) {
    var keepMe = (localStorage.getItem('keepMe')) ? localStorage.getItem('keepMe') : null;
    if(keepMe != 'Active'){

      //this.userLogout();
    }
    $event.returnValue;
  }

  ngOnInit(){
    /* Remove leftover Google Places autocomplete dropdown
       which is appended to <body> and survives Angular navigation */
    this.router.events.subscribe(() => {
    const pacContainers = document.getElementsByClassName('pac-container');
    if (pacContainers.length) {
      const parent = pacContainers[0].parentNode;
      if (parent) {
        parent.removeChild(pacContainers[0]);
      }
    }
  });
    console.log('is jquery init:::::::::::;;',$.fn.jquery);  // This will print the jQuery version loaded

    this._feed._feed$.subscribe((feedsRes) => {

      if(feedsRes['trigger']){
        setTimeout(() => {
            this.eventEmit.triggerSocketService(feedsRes['type']);
            if(feedsRes['type'] === 'groupMsg'){
              this.updateGroupCount();
            }
        }, 1000);
      }
    })

    //this._feed.getAllFeeds();
    // Scroll the page to top on router change
    this.router.events.subscribe((evt) => {

      if(this.httpService.isLocalAuthenticated()){
        if(!this.isSocketConnected){
          setTimeout(() => {
            this._feed.getAllFeeds();
            this.eventEmit.triggerSocketService('all');
          }, 1500);
          this.isSocketConnected = true;
        }
      }

      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
    // Scroll the page to top on router change ends

    //Script for closing the collapse menu
    $(document).click(function (event) {
        var clickover = $(event.target);
        var _opened = $(".navbar-collapse").hasClass("in");
        if (_opened === true && !clickover.hasClass("navbar-toggle")) {
            $("button.navbar-toggle").click();
        }
    })

    this.eventEmit.eventEmit$.subscribe((data)=>{
      if(data.isSessionSet || data.profilepictureUpdate){
        this.userInfo.getUserInfo();
      }
    });
    /** check the building manager exist or not */
    this.userInfo.checkForBuildingManager(this.id);

    $(document.body).bind("dragover", function (e) {
      e.preventDefault();
      return false;
    });

    $(document.body).bind("drop", function (e) {
      e.preventDefault();
      return false;
    });
    var that = this;
    $(document).click(function(){
      $('#img_upload_modal').on('hidden.bs.modal', function () {
        that.eventEmit.eventEmit$.next({modalClose: true});
      })
    })
    $(document).on('ready click',function () {
      $('#img_upload_modal').on('shown.bs.modal', function () {
        that.eventEmit.eventEmit$.next({ modalOpen: true });
      })
    })
    // Fetch information stored on localStorage
    this.id = (localStorage.getItem('residents')) ? localStorage.getItem('residents') : null;
    this.isManager = localStorage.getItem('isManager');
    this.userBuildingId = localStorage.getItem('userBuildingId');
    this.route.params.forEach((params: Params) => {});

    this.router.events.subscribe((data:any) => {
      if (data instanceof NavigationEnd) {
        this.currentUrl = data.url; // Now currentUrl will only update for NavigationEnd events
        console.log('currentUrl:', this.currentUrl);
        this.eventEmit.eventEmit$.next({ currentPageUrl: this.currentUrl });
      }
      setTimeout(() => {
        this.eventEmit.eventEmit$.next({ currentPageUrl : data.url });
      },5000);


      //Check idle time for inactive session
      var currentDate = new Date();
      var currentTime = currentDate.getTime().toString();
      var getStartTime = localStorage.getItem('activeTime');

      var difference = Number(currentTime) - Number(getStartTime); // This will give difference in milliseconds
      var resultInMinutes = Math.round(difference / 60000);
      // console.log("ResultInMin =======", resultInMinutes);

      if(resultInMinutes <= 10){
          localStorage.setItem('activeTime', currentTime);
      }else if(resultInMinutes > 10){
          var keepMe = (localStorage.getItem('keepMe')) ? localStorage.getItem('keepMe') : null;
          var residentsId = (localStorage.getItem('residents')) ? localStorage.getItem('residents') : null;
          // if( (residentsId != null) && (keepMe != 'Active')){
          //   //this.userLogout();
          // }
      }

      $(window).ready(function () {
        var BrowserDetect = {
          init: function () {
            this.browser = this.searchString(this.dataBrowser) || "Other";
            this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";

            return { browser: this.browser, version: this.version }

          },
          searchString: function (data) {
            for (var i = 0; i < data.length; i++) {
              var dataString = data[i].string;
              this.versionSearchString = data[i].subString;

              if (dataString.indexOf(data[i].subString) !== -1) {
                return data[i].identity;
              }
            }
          },
          searchVersion: function (dataString) {
            var index = dataString.indexOf(this.versionSearchString);
            if (index === -1) {
              return;
            }

            var rv = dataString.indexOf("rv:");
            if (this.versionSearchString === "Trident" && rv !== -1) {
              return parseFloat(dataString.substring(rv + 3));
            } else {
              return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            }
          },

          dataBrowser: [
            { string: navigator.userAgent, subString: "Edge", identity: "MS Edge" },
            { string: navigator.userAgent, subString: "MSIE", identity: "Explorer" },
            { string: navigator.userAgent, subString: "Trident", identity: "Explorer" },
            { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
            { string: navigator.userAgent, subString: "Opera", identity: "Opera" },
            { string: navigator.userAgent, subString: "OPR", identity: "Opera" },

            { string: navigator.userAgent, subString: "Chrome", identity: "Chrome" },
            { string: navigator.userAgent, subString: "Safari", identity: "Safari" }
          ]
        };

        var browserD = BrowserDetect.init();
        // console.log("You are using <b>" + browserD.browser + "</b> with version <b>" + browserD.version + "</b>");
        if (browserD.browser == 'Safari') {
          $('body').addClass('Safari');
        }
        else if (browserD.browser == 'Firefox') {
          $('body').addClass('Firefox');
        }
        else if (browserD.browser == 'MS Edge') {
          $('body').addClass('edge');
        }
        else {
          $('body').addClass('Webkit');
        }
      });
      this.link.getLink(data.url)
      // console.log(data, 'urrrrrr')
      if (data.url == '/allgroups' || data.url == '/messages' || data.url == '/groups'){
        $('.body_click #img_upload_modal .close').click(function(){
          $('#img_upload_modal').trigger('click');
        });
        $(document).on('click', function (event) {
          if (!$(event.target).closest('.modal-content').length) {
            $('.modal-backdrop').remove();
          }
        });
        this.document.body.classList.add('body_click');
        $('#img_upload_modal .close').removeAttr('data-dismiss');
      }else{
        this.document.body.classList.remove('body_click');
        $('#img_upload_modal .close').attr('data-dismiss','modal');
      }
      if (data.url == '/user/settings/payment'){
        $('body').addClass('paymentSettings');
        if(localStorage.getItem('isManager') == 'true'){}else{
          this.router.navigate(['/feed']);
        }
      }
      else{
        $('body').removeClass('paymentSettings');
      }

      if (data.url == '/buildings/alerts') {
        $('body').addClass('alerts');
      }
      else {
        $('body').removeClass('alerts');
      }

      if(_.isUndefined(data.urlAfterRedirects) === false){
        if(data.urlAfterRedirects.queryParams){

          if(data.urlAfterRedirects.queryParams.login || data.urlAfterRedirects.queryParams.error
          || data.urlAfterRedirects.queryParams.exist){
            if(data.urlAfterRedirects.queryParams.login == 'true' || data.urlAfterRedirects.queryParams.error == 'err' ||
            data.urlAfterRedirects.queryParams.exist == 'true'){
              // console.log(data.urlAfterRedirects.queryParams.login, "============>>>>>>>>>");
              this.link.detectLink('open');
            }else{
              this.link.detectLink('notOpen');
            }
          }

          if(data.urlAfterRedirects.queryParams.id){
              // console.log(data.urlAfterRedirects.queryParams, '................');
            this.localId = data.urlAfterRedirects.queryParams.id;
            this.isAManager = data.urlAfterRedirects.queryParams.type;
            this.buildingIds = data.urlAfterRedirects.queryParams.buildings;
            if(data.urlAfterRedirects.queryParams.token){
              localStorage.setItem('token', data.urlAfterRedirects.queryParams.token)
            }
            if(this.isAManager == 'manager'){
              this.isAManager = 'true';
            }else if(this.isAManager == 'admin'){
              this.isAManager = 'false';
              this.type = 'admin'
             }
            else{
              this.isAManager = 'false';
            }
            localStorage.setItem('residents', this.localId);
            localStorage.setItem('isManager', (this.type == 'manager') ? this.type : this.isAManager);
            localStorage.setItem('type', data.urlAfterRedirects.queryParams.type);
            localStorage.setItem('userBuildingId', this.buildingIds.toString());
            this.userInfo.checkForBuildingManager(this.localId);
            }
        }
      }

      // this.currentUrl = data.url;
      // console.log('Current URL : ' , this.currentUrl);
      if(this.currentUrl == '/'){
        $('.banner .flexInput input').focus();


          this.plan.resetUserPlan();

          //if(this.httpService.isLocalAuthenticated() === true){
            this.httpService.isAuthenticated().subscribe((data:any)=>{
              // console.log(data, "...................................")
              // if(!data.authenticated){
              //   localStorage.clear();
              //   sessionStorage.removeItem('existingBuildingImage');
              //   sessionStorage.removeItem('userId');
              // }else{

              //   let buildingIds = [];
              //   if(data.user.building && data.user.building.length > 1){
              //     for(let building of data.user.building) {
              //       buildingIds.push(building.id);
              //     }
              //   }

              //  // localStorage.setItem('userBuildingId', buildingIds.toString());
              //   localStorage.setItem('residents', data.user.id);
              //   sessionStorage.setItem('userId', data.user.id);
              //   localStorage.setItem('type', data.user.type);
              //   if(data.user.type === 'manager'){
              //     let isManager = true;
              //     localStorage.setItem('isManager', isManager.toString());
              //     localStorage.setItem('userBuildingId', buildingIds.toString());
              //   }else{
              //     let isManager = false;
              //     localStorage.setItem('isManager', isManager.toString());
              //     localStorage.setItem('userBuildingId', data.user.building[0].id);
              //   }
              //   localStorage.setItem('maintenance', data.user.isMaintenanceManager);
              // }
            });
          //}
      }
      if(this.currentUrl == '/' || this.currentUrl == '/?error=err#_=_' || this.currentUrl == '/#_=_'){
        $('body').addClass('homepageWrap');
      }else{
     // if(this.currentUrl !== '/'){
        this.authenticationCheck();
        $('body').removeClass('homepageWrap');
      }

      if(this.currentUrl == '/messages'){
        this.chatWindow = false;
      }
      const enableCheck = typeof this.currentUrl !== 'undefined' && (this.currentUrl === '/' || this.currentUrl==='/pricing' || this.currentUrl=== '/product' || this.currentUrl.includes('/managerprofile/payment'));
      if(enableCheck && this.isScriptAdded){
        this.isScriptAdded = false;
        const s = this.document.createElement('script');
        s.type = 'text/javascript';
        s.src = 'assets/js/intercom.js';
        const __this = this;
        this.elementRef.nativeElement.appendChild(s);

      }else{
        if(enableCheck){
          $('.intercom-launcher-frame').css('display','block');
          $('.intercom-launcher-discovery-frame').css('display','block');
        }else{
          $(document).ready(function(){
            $('.intercom-launcher-frame').css('display','none');
            $('.intercom-launcher-discovery-frame').css('display','none');
        });
        }



      }

      this.currentUrl === '/pricing' ? $('.headWholeWrap').addClass('pricing') : $('.headWholeWrap').removeClass('pricing');
      this.currentUrl === '/about-us' ? $('.headWholeWrap').addClass('transparent') : $('.headWholeWrap').removeClass('transparent');

      if ((this.currentUrl && (this.currentUrl.startsWith('/?') || this.currentUrl === '/pricing' || this.currentUrl === '/product' || this.currentUrl === '/about-us' || this.currentUrl === '/' ||  this.currentUrl.startsWith('/#'))) && this.isAuthenticated !== true){
        this.eventEmit.eventEmit$.next({headerToggle: true, localAuth: this.httpService.isLocalAuthenticated()});
        $('body').removeClass('fixedHeader');
      }else{
        this.eventEmit.eventEmit$.next({headerToggle: false,localAuth: this.httpService.isLocalAuthenticated()});
        $('body').addClass('fixedHeader');
      }
    });

    // Check if a user has been successfuly authenticated dynamically based on value change
    /*this.authenticatedSub.subscribe(
      (res) => {
        console.log('Is Authenticated : ' , res);
        var response = JSON.parse(JSON.stringify(res));
        this.isAuthenticated = response.authenticated;
        this.userProfile = response.user;
      }
    );*/

    let modalParam = this.route.queryParams;
    let name = this.route.queryParams.subscribe((result)=>{
      // console.log('queryparam subscribe',result);
    });
    let error = this.route.snapshot.params['id'];
    // console.log(modalParam, error,name, 'hello');
  }

  ngAfterViewInit() {
    setTimeout(()=>{
      this.id = (localStorage.getItem('residents')) ? localStorage.getItem('residents') : null;
      this.link.detectLink('notOpen');
      this.link.getUserId(this.id)
      if(this.httpService.isLocalAuthenticated()){
        this.userInfo.getUserInfo();
      }
    },3000)

  }

  authenticationCheck() {
     if(this.httpService.isLocalAuthenticated() === true){
       this.isAuthenticated = true;
     }else{
       localStorage.clear();
       this.isAuthenticated = false;
     }
  }

  userLogout(){
    /*const header = new Headers();
    header.append('Content-Type', 'application/json');*/
    this.httpService.logout().pipe(map(res=>res)).subscribe((res)=>{
        // console.log(res);
        if(res){
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/';
        }
    });
  }

  updateGroupCount(){
    var i = 0;
    var timer = setInterval(()=>{
        this.eventEmit.triggerSocketService('groupMsg');
        i++;
        if(i === 2){
            clearInterval(timer)
        }
    }, 2000)
  }
}
